import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

class WebComponent extends HTMLElement {
  async connectedCallback() {
    ReactDOM.render(<App />, this);
  }
}

const ELEMENT_ID = "voebiz-react-update-member";

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
